/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Box } from "@material-ui/core";

import type { FC } from "react";

export const StreamingIconButtonWithText: FC<{
  children: React.ReactNode;
  isDarkModeEnabled: boolean;
  onClick: () => void;
}> = ({ children, isDarkModeEnabled, onClick }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      gridGap={"4px"}
      minWidth={"fit-content"}
      height={"32px"}
      paddingX={"12px"}
      color={isDarkModeEnabled ? "dark.icon.primary" : "light.icon.primary"}
      bgcolor={isDarkModeEnabled ? "#333333" : "#F5F5F5"}
      borderRadius={"24px"}
      onClick={onClick}
      css={css`
        cursor: "pointer";
        transition: 0.5s;
        &:hover {
          background-color: ${isDarkModeEnabled ? "#444444" : "#E8E8E8"};
        }
      `}
    >
      {children}
    </Box>
  );
};
